import React from 'react'
import { useAppSelector } from 'src/app/hooks'
import { Currency, Deposit } from 'src/core/models'
import { currencyListSelector } from 'src/features'
import styles from './DepositMovileViewColumn.module.scss'
import { getFormatedPrice, getTransformedDate } from 'src/core/helpers'
import { FormLabels, DepositsStatusColumn, DepositsActionColumn } from 'src/components'

const DepositMovileViewColumn: React.FC<{ deposit: Deposit }> = ({ deposit }) => {
  const currencyList = useAppSelector(currencyListSelector)
  const code = currencyList?.find((c: Currency) => c.id === deposit?.currency_token_id)?.code

  return <>
    <FormLabels
      title={deposit.internal_reference}
      subtitle={getFormatedPrice(deposit?.total, code)}
      thirdLabel={getTransformedDate(deposit.created)}
    />
    <div className={styles.content}>
      <DepositsStatusColumn deposit={deposit} />
      <div className={styles.actions}>
        <DepositsActionColumn deposit={deposit} />
      </div>
    </div>
  </>
}

export default DepositMovileViewColumn
